import { ReactNode } from 'react';
import type { AccessRule } from '../model/access-rule';
import { useRulesAccess } from '../model/use-rules-access';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  rule?: AccessRule;
}

export const RulesAccess = ({ children, rule, fallback }: Props) => {
  const allowed = useRulesAccess(rule);
  if (allowed) return <>{children}</>;
  return <>{fallback ?? null}</>;
};